export default class EditClientViewmodel {
    public id: number = 0;
    public name: string = '';
    //public logo: string | null = null;
    public alertThreshold: string = '';
}